import styled, { CSSProperties } from "styled-components";

export const StyledTemplate = styled.div<{
  $display?: CSSProperties["display"];
}>`
  display: ${(props) => props.$display ?? "inline-block"};
`;
